import Button from "../../../components/Button";
import { useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import Badge from "../../../components/Badge";
import { Icon } from "@iconify/react";
import { httprequest } from "../../../data/api";
// import { useNavigate } from "react-router-dom";
import Modal from "../../../components/Modal";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";
// import useStyles from "./styles";

const INVENTORY_ENDPOINT = "/api/v1/hostel-management/inventory";

const ArchivedInventory = () => {
  // const classes = useStyles();
  // const navigate = useNavigate();
  const [searchResult, setSearchResult] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [archiving, setIsArchiving] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const width = useWindowSize();
  const mobile = width < 600;

  /**
 * Closes the delete modal by setting the deleteModal state to false.
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  /**
 * get all inventory
 */
  const getAllInventory = () => {
    setIsLoading(true);
    httprequest.get(`${INVENTORY_ENDPOINT}?status=archived`).then((res) => {
      setIsLoading(false);
      setInventoryData(res?.data?.data?.inventories);
      setSearchResult(res?.data?.data?.inventories);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err?.response?.data);
    });
  };

  const handleArchive = (row) => {
    setCurrentRow(row);
    setArchiveModal(!archiveModal);
  };

  const handleCloseArchiveModal = () => {
    setArchiveModal(false);
    setCurrentRow({});
  };

  const handleArchiveInventory = () => {
    setIsArchiving(true);
    httprequest.patch(`${INVENTORY_ENDPOINT}/${currentRow?.id}`, { status: "active" }).then(() => {
      setIsArchiving(false);
      handleCloseArchiveModal();
      getAllInventory();
      toast.success("Inventory Archived Succesfully");
    }).catch((err) => {
      setIsArchiving(false);
      toast.error(err?.response?.data);
    });
  };

  // On Page Load, set search result data to be the initial data
  useEffect(() => {
    getAllInventory();
  }, []);
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Employee In-Charge",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Employee In-Charge</p>}
          {`${row?.employee_in_charge?.last_name} ${row?.employee_in_charge?.first_name}` || "--/--"}
        </>
      )
    },
    {
      name: "Category",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Category</p>}
          {row?.category?.category || "--/--"}
        </>
      )
    },
    {
      name: "Condition",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Condition</p>}
          {row?.condition || "--/--"}
        </>
      )
    },
    {
      name: "Created At",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Created At</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => handleArchive(row)}
            className="table-action-icon"
          >
            <Icon icon="clarity:unarchive-line" />
          </button>
          {/* <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button> */}
        </div>
      )
    }
  ];

  // --| Filter Teacher table using name, email and class
  const handleSearchTeacher = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = inventoryData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                      data?.title
                        ?.toLowerCase()
                        .includes(word.toLowerCase()) ||
                      data?.label
                        ?.toLowerCase()
                        .includes(word.toLowerCase()) ||
                        data?.type
                          ?.toLowerCase()
                          .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <div>
      <div className="page-content margin-top-16">
        {isLoading ? (
          <PageLoader />
        ) : (
          <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
            <TableSearch placeholder="Search here..." searchTableFunc={handleSearchTeacher} />}
          />
        )}
      </div>
      {/* Delete Modal */}
      <Modal
        title="Delete Inventory"
        subtitle={
          <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.title}</span>. If deleted, employee will no longer have access to this Inventory.
          </div>}
        modalContent={
          <>

          </>
        }
        modalFooter={
          <>
            <Button variant="danger" buttonName="Delete Evaluation" buttonSize="full" color="btndefault" />
          </>
        }
        isopen={deleteModal}
        closeModal={handleCloseDeleteModal}
      />

      {/* Archive Modal */}
      <Modal
        title="Un-Archive Inventory"
        subtitle={
          <div>Are you sure you want to unarchive <span className="modal-name-highlight">{currentRow?.name}</span>. If unarchived, employee will have access to this Inventory.
          </div>}
        modalContent={
          <>

          </>
        }
        modalFooter={
          <>
            <Button variant="danger" buttonName="Un-Archive Inventory" buttonSize="full" color="btndefault" onClick={handleArchiveInventory} isLoading={archiving} />
          </>
        }
        isopen={archiveModal}
        closeModal={handleCloseArchiveModal}
      />
      {/* <ToastContainer /> */}
    </div>
  );
};

export default ArchivedInventory;
